<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div>
      <!-- <div class="intro-y flex flex-col sm:flex-row"> -->
      <!-- <h1 class="text-lg font-medium mr-auto">
          เพิ่มสมาชิก
        </h1> -->
        <div class="mb-2 mt-8">
          <div class="flex items-center">
          <h1 class="text-lg font-medium mr-2">
            เพิ่มสมาชิก
          </h1>
          <button
            class="btn btn-primary mr-auto"
            type="button"
            @click="openConnectModal"
            v-if="memberData.nationality == 'ไทย'"
          >
            ตรวจสอบกับระบบอื่น
          </button>
        </div>
        <!-- <div class="col-span-6 mr-auto">
          <button
            class="btn btn-primary"
            type="button"
            @click="openConnectModal"
          >
            ตรวจสอบกับระบบอื่น
          </button>
        </div> -->
      </div>
      <!-- <div class="mb-2 grid grid-cols-12 gap-2 mt-8">
        <div class="col-span-12 sm:col-span-6 items-center">
          <h1 class="text-lg font-medium mr-auto">
            เพิ่มสมาชิก
          </h1>
        </div>
        <div class="col-span-12 sm:col-span-6 text-right">
          <button
            class="btn btn-primary"
            type="button"
            @click="openConnectModal"
          >
            ตรวจสอบกับระบบอื่น
          </button>
        </div>
      </div> -->
      <!-- </div> -->
      <div class="intro-y box py-10 sm:py-20 mt-5">
        <form-wizard />
      </div>
    </div>
    <selectDataConnection :memberData="memberData"/>
  </template-layout>
</template>

<script>
import  { ref, defineComponent, reactive, onMounted, watch } from "vue";
import formWizard from "@/components/member-wizard/index.vue";
import selectDataConnection from "./container/selectDataConnection.vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import { useRoute } from "vue-router";
import {useStore} from "vuex"
export default defineComponent({
  components: {
    formWizard,
    TemplateLayout,
    selectDataConnection,
  },
  setup() {
    const route = useRoute();
     const memberData = ref({
      nationality: 'ไทย',
      national_id: null,
      nationality_other: null
    });
    const store = useStore()

      const loadMemberDataFromQuery = () => {
      if (route.query.fromSearch === 'true') {
        memberData.value = {
          nationality: route.query.nationality || 'ไทย',
          national_id: route.query.national_id || null,
          nationality_other: route.query.nationality_other || null
        };
        store.dispatch('main/updateExternalData',{ system:null,data:null})
        console.log('✅ memberData loaded:', memberData.value);
        console.log('   Show button?', memberData.value.nationality == 'ไทย');
      }
    };

    onMounted(() => {
      loadMemberDataFromQuery();
    });
    
    watch(() => route.query, () => {
      loadMemberDataFromQuery();
    }, { deep: true });

    const breadcrumbComputed = reactive([
      {
        name: "ครัวเรือน",
        path: "main-house-hold",
      },
      {
        name: "ข้อมูลครัวเรือน",
        path: "household-profile",
        param: { hhid: route.query.hhid },
      },
      {
        name: "ข้อมูลครอบครัว",
        path: "family-profile",
        param: { famid: route.params.famid },
      },
      {
        name: "บุคคล",
        active: true,
      },
    ]);
    const openConnectModal = () => {
      // เปิด modal selectDataConnection
      cash("#select-connect-modal").modal("show");
    };
    return {
      breadcrumbComputed,
      openConnectModal,
      memberData
    };
  },
});
</script>

<style lang="scss"></style>
